import { get_short_date_DAYMMMDD, convert24HTimeToAMPM } from "./general";
import { markup } from "./Prices";
import { get_currency_symbol } from "./general";

const FlightConfirmationEmailMarkup = (completedOrderDetails) => {

    const FIRST_SLICE_ORIGIN_IATA=(
        completedOrderDetails?.slices 
        && completedOrderDetails?.slices[0].segments 
        && completedOrderDetails?.slices[0].segments[0].origin?.iata_code
    );
    const FIRST_SLICE_CITY_NAME=(
        completedOrderDetails?.slices 
        && completedOrderDetails?.slices[0].segments 
        && completedOrderDetails?.slices[0].segments[0].origin?.city_name
    );
    const LAST_SLICE_DESTINATION_IATA=(
        completedOrderDetails?.slices 
        && completedOrderDetails?.slices[(completedOrderDetails?.slices?.length - 1)].segments 
        && completedOrderDetails?.slices[(completedOrderDetails?.slices?.length - 1)]
        .segments[(completedOrderDetails?.slices[(completedOrderDetails?.slices?.length - 1)]?.segments?.length - 1)].destination?.iata_code
    );
    const LAST_SLICE_CITY_NAME=(
        completedOrderDetails?.slices 
        && completedOrderDetails?.slices[(completedOrderDetails?.slices?.length - 1)].segments 
        && completedOrderDetails?.slices[(completedOrderDetails?.slices?.length - 1)]
        .segments[(completedOrderDetails?.slices[(completedOrderDetails?.slices?.length - 1)]?.segments?.length - 1)].destination?.city_name
    );

    const DESTINATION_IATA=(
        completedOrderDetails?.slices 
        && completedOrderDetails?.slices[0].segments 
        && completedOrderDetails?.slices[0].segments[0].destination?.iata_code
    );
    const DESTINATION_CITY_NAME=(
        completedOrderDetails?.slices 
        && completedOrderDetails?.slices[0].segments 
        && completedOrderDetails?.slices[0].segments[0].destination?.city_name
    );;

    const SLICES_LENGHT = completedOrderDetails?.slices?.length;
    let is_one_way=(SLICES_LENGHT<2);
    let is_round_trip=(
        SLICES_LENGHT===2 
        && (FIRST_SLICE_ORIGIN_IATA===LAST_SLICE_DESTINATION_IATA)
    );

    const _date_time=(
        completedOrderDetails?.slices
        && completedOrderDetails?.slices[0]?.segments
        && completedOrderDetails?.slices[0]?.segments[0]?.departing_at
    )
    const FLIGHT_DATE=(get_short_date_DAYMMMDD((_date_time || "")));
    const _time=(
        completedOrderDetails?.slices
        && completedOrderDetails?.slices[0]?.segments
        && completedOrderDetails?.slices[0]?.segments[0]?.departing_at?.split("T")[1]
    );
    const TAKE_OFF_TIME=convert24HTimeToAMPM((_time || ""));

    let SEGMENTS = "";
    completedOrderDetails?.slices?.forEach((slice, index)=>{

        SEGMENTS+=`<div style="margin-bottom: 10px;">
            <span style="cursor: pointer; font-size: 15px; color: green; font-family: 'Prompt', Sans-serif;">
                ${slice.origin.city_name} to ${slice.destination.city_name}
            </span>
        </div>`;

        slice.segments.forEach(segment=> {
            let seats="";
            let total_checked_baggages=0;
            let total_carry_on_baggages=0;
            segment.passengers.forEach(passenger=>{
                seats+= passenger.seat ? `${passenger.seat}, ` : "_";
                passenger.baggages.forEach(baggage=>{
                    if(baggage.type==="checked"){
                        total_checked_baggages+=parseInt(baggage.quantity);
                    }
                    if(baggage.type==="carry_on"){
                        total_carry_on_baggages+=parseInt(baggage.quantity);
                    }
                });

                completedOrderDetails.passengers.forEach(flight_passenger=>{
                    if(passenger.passenger_id===flight_passenger.id){
                        flight_passenger.extras=passenger;
                    }
                });
            });

            SEGMENTS+=
                `<div style="display: flex; padding-bottom: 13px; padding-left: 10px;">
                    <div style="border-left: 3px solid green; padding-left: 10px;">
                        <p style="font-family: 'Prompt', Sans-serif; font-size: 14px;">
                            ${segment.origin.iata_code}, ${segment.origin.city_name}
                            <span style="margin: 0 10px; font-family: 'Prompt', Sans-serif; font-size: 14px; color: rgba(0,0,0,0.6);">
                                to
                            </span>
                            ${segment.destination.iata_code}, ${segment.destination.city_name}
                        </p>
                        <div style="padding-left: 10px;">
                            <p style="font-family: 'Prompt', Sans-serif; font-size: 13px; color: rgba(0,0,0,0.7);">
                                ${segment.origin.name}
                                <span style="margin: 0 10px; font-family: 'Prompt', Sans-serif; font-size: 14px; color: rgba(0,0,0,0.6);">
                                    to
                                </span>
                                ${segment.destination.name}
                            </p>
                            <p style="font-family: 'Prompt', Sans-serif; font-size: 13px; color: rgba(0,0,0,0.7);">
                                ${get_short_date_DAYMMMDD(segment?.departing_at) + " ("}
                                ${convert24HTimeToAMPM(segment?.departing_at.split("T")[1]) + ")"}
                                <span style="margin: 0 10px; font-family: 'Prompt', Sans-serif; fontSize: 14px; color: rgba(0,0,0,0.6);">
                                    to
                                </span>
                                ${get_short_date_DAYMMMDD(segment.arriving_at) + " ("}
                                ${convert24HTimeToAMPM(segment.arriving_at.split("T")[1]) + ")"}
                            </p>
                            <p style="font-family: 'Prompt', Sans-serif; font-size: 13px; color: rgba(0,0,0,0.7);">
                                This flight is operated by ${segment.operating_carrier.name}. ${segment.operating_carrier.conditions_of_carriage_url && `<a href="${segment.operating_carrier.conditions_of_carriage_url}" rel="noreferrer" target="_blank">
                                Please click here to learn more about the airline conditions</a>`}
                            </p>
                            <p style="font-family: 'Prompt', Sans-serif; font-size: 13px; color: rgba(0,0,0,0.7);">
                                <span style="font-weight: bolder; font-family: 'Prompt', Sans-serif; font-size: 14px;">
                                    Take off: ${convert24HTimeToAMPM(segment?.departing_at.split("T")[1])}
                                </span>, Aircraft: ${segment.aircraft.name}, Checked bags: ${total_checked_baggages}, Carry-on bags: ${total_carry_on_baggages}
                            </p>
                            <p style="font-family: 'Prompt', Sans-serif; font-size: 13px; color: rgba(0,0,0,0.7);">
                                Seat: ${seats}
                            </p>
                        </div>
                    </div>
                </div>`
        })
    });

    // Generating passengers markup
    let PASSENGERS="";
    completedOrderDetails?.passengers?.forEach(passenger=>{

        let seat=passenger.extras.seat || "unspecified";
        let total_checked_baggages=0;
        let total_carry_on_baggages=0;
        let cabin_class = passenger.extras.cabin_class;
        let email=passenger.email;
        let phone=passenger.phone_number;
        let name = `${passenger.given_name} ${passenger.family_name}`
        passenger.extras.baggages.forEach(baggage=>{
            if(baggage.type==="checked"){
                total_checked_baggages+=parseInt(baggage.quantity);
            }
            if(baggage.type==="carry_on"){
                total_carry_on_baggages+=parseInt(baggage.quantity);
            }
        });

        PASSENGERS+=`
            <div style="padding-bottom: 10px; margin-right: 25px;">
                <div>
                    <p style="font-family: 'Prompt', Sans-serif; font-size: 14px;">
                        ${name}
                    </p>
                    <div style="padding-left: 10px, margin-left: 10px; border-left: 3px solid green;">
                        <p style="font-family: 'Prompt', Sans-serif; font-size: 13px; color: rgba(0,0,0,0.7);">
                            ${email}, ${phone}
                        </p>
                        <p style="font-family: 'Prompt', Sans-serif; font-size: 13px; color: rgba(0,0,0,0.7);">
                            Seat: ${seat}, Cabin: ${cabin_class}, Checked bags: ${total_checked_baggages}, Carry-on bags: ${total_carry_on_baggages}
                        </p>
                    </div>
                </div>
            </div>`;
    });

    let IMPORTANT_NOTICES="";
    if(completedOrderDetails?.conditions?.refund_before_departure?.allowed){
        const CURRENCY_SYMBOL=get_currency_symbol(completedOrderDetails?.conditions?.refund_before_departure?.penalty_currency);
        IMPORTANT_NOTICES+=`
            <div>
                <div>
                    <p style="font-family: 'Prompt', Sans-serif; font-size: 13px;">
                        Refund allowed with penalty amount of 
                        <span style="margin-left: 5px; font-family: 'Prompt', Sans-serif; fontSize: 13px;">
                        ${CURRENCY_SYMBOL}</span>
                        ${(markup(completedOrderDetails?.conditions?.refund_before_departure?.penalty_amount).new_price).toFixed(2)}
                    </p>
                </div>
            </div>`;
    }else{
        IMPORTANT_NOTICES+=`
            <div>
                <div>
                    <p style="font-family: 'Prompt', Sans-serif; font-size: 13px;">
                        No refunds available for this flight
                    </p>
                </div>
            </div>`;
    }

    if(completedOrderDetails?.conditions?.change_before_departure?.allowed){
        const CURRENCY_SYMBOL=get_currency_symbol(completedOrderDetails?.conditions?.change_before_departure?.penalty_currency);
        IMPORTANT_NOTICES+=`
            <div>
                <div>
                    <p style="font-family: 'Prompt', Sans-serif; font-size: 13px;">
                        Changes allowed with penalty amount of
                        <span style="margin-left: 5px; font-family: 'Prompt', Sans-serif; font-size: 13px;">
                        ${CURRENCY_SYMBOL}</span>
                        ${(markup(completedOrderDetails?.conditions?.change_before_departure?.penalty_amount).new_price).toFixed(2)}
                    </p>
                </div>
            </div>`;
    }else{
        IMPORTANT_NOTICES+=`
            <div>
                <div>
                    <p style="font-family: 'Prompt', Sans-serif; font-size: 13px;">
                        Changes are not allowed for this flight
                    </p>
                </div>
            </div>`;
    }

    let overallTotal = parseFloat(completedOrderDetails.total_amount);
    const { services } = completedOrderDetails;
    let EXTRAS_MARKUP = "";
    services.forEach(each=>{
        overallTotal=(overallTotal+each.total_amount);
        EXTRAS_MARKUP+=`
            <div>
                <p style="font-size: 13px; letter-spacing: 1px; color: rgba(0,0,0,0.9);">
                    ${each.type} (${each.quantity}):
                    <span style="font-size: 14px; font-family: 'Prompt', Sans-serif; color: rgba(0,0,0,0.7); margin-left: 5px;">
                    ${get_currency_symbol(each.total_currency)}</span>
                    ${(markup(each.total_amount).new_price).toFixed(2)}
                </p>
            </div>`;
    });

    return `
        <div style="position: relative;">
            <div style="padding: 20px 0;">
                <div style="padding: 0 10px;">
                    <p style="font-family: 'Prompt', Sans-serif; font-size: 15px; color: green; font-weight: bolder;">
                        Reference Number:
                        <span style="font-family: 'Prompt', Sans-serif; margin-left: 5px; color: rgba(0,0,0,0.7); font-size: 13px;">
                            ${completedOrderDetails.booking_reference}
                        </span>
                    </p>
                </div>
                <div>
                        <div style="border: 1px dashed rgba(0,0,0,0.1); padding: 10px;">
                            <div style="margin-bottom: 10px;">
                            <p style="font-family: 'Prompt', Sans-serif; font-size: 14px; font-weight: bolder;">
                                ${is_one_way ? ` One way: `: ""}
                                ${is_round_trip ? ` Round trip: ` : ""}    
                                ${FIRST_SLICE_CITY_NAME} - ${FIRST_SLICE_ORIGIN_IATA}
                                <span style="margin: "0 5px; font-weight: initial; font-size: 14px;">
                                    to</span>
                                ${DESTINATION_CITY_NAME} - ${DESTINATION_IATA}
                            </p>
                            <p style="font-family: 'Prompt', Sans-serif; font-size: 14px;">
                                Your booking reference is
                                <span style="font-weight: bolder; font-family: 'Prompt', Sans-serif; margin-left: 5px; color: rgba(0,0,0,0.9); font-size: 13px;">
                                    ${completedOrderDetails.booking_reference}
                                </span>
                            </p>
                            <p style="font-family: 'Prompt', Sans-serif; font-size: 13px; color: rgba(0,0,0,0.7);">
                                Please remember your flight is on
                                <span style="font-family: 'Prompt', Sans-serif; font-size: 13px; margin: 0 10px; color: black; font-weight: bolder;">
                                    ${FLIGHT_DATE}</span>
                                and takes off at
                                <span style="font-family: 'Prompt', Sans-serif; font-size: 13px; margin: 0 10px; color: black; font-weight: bolder;">
                                    ${TAKE_OFF_TIME}</span>
                            </p>
                        </div>
                        <h1 style="font-family: 'Prompt', Sans-serif; font-size: 17px; margin-bottom: 10px; margin-top: 25px;">
                            Flights</h1>
                        <div>
                            ${SEGMENTS}
                        </div>
                        <h1 style="font-family: 'Prompt', Sans-serif; font-size: 17px; margin-bottom: 10px; margin-top: 25px;">
                            Passengers</h1>
                        <div>
                            <div style="display: flex; flex-wrap: wrap;">
                                ${PASSENGERS}
                            </div>
                        </div>

                        <div>
                        <h1 style="font-family: 'Prompt', Sans-serif; font-size: 17px; margin-bottom: 10px; margin-top: 25px;">
                            Sold by</h1>
                        <div>
                            <div style="margin-bottom: 10px;">
                                <p style="color: rgba(0,0,0,0.8); font-size: 12px; font-family: 'Prompt', Sans-serif; margin-top: 10px;">
                                    <img src="${completedOrderDetails?.owner?.logo_symbol_url}" alt="todo" 
                                    style="width: 27px; height: auto; margin-right: 10px; object-fit: cover;" />
                                    ${completedOrderDetails?.owner?.name}
                                </p>
                                ${
                                    completedOrderDetails?.owner?.conditions_of_carriage_url ?
                                    `<p style="font-family: 'Prompt', Sans-serif; font-size: 14px;">
                                        <a href="${completedOrderDetails?.owner?.conditions_of_carriage_url}"  rel="noreferrer" target="_blank">
                                            read more at ${completedOrderDetails?.owner?.conditions_of_carriage_url}
                                        </a>
                                    </p>` : 
                                    `<p style="font-family: 'Prompt', Sans-serif; fontSize: 13px;">
                                        Airline website not found
                                    </p>`
                                }
                            </div>
                        </div>
                        <h1 style="font-family: 'Prompt', Sans-serif; font-size: 17px; margin-bottom: 10px; margin-top: 25px;">
                            Payment Details</h1>
                            <div style="margin-bottom: 10px; padding-left: 10px;">
                                <p style="font-family: 'Prompt', Sans-serif; font-size: 13px;">
                                    Base Amount: <span style="font-size: 14px; font-family: 'Prompt', Sans-serif; color: rgba(0,0,0,0.7);" >
                                    ${get_currency_symbol(completedOrderDetails.base_currency)}</span>
                                    ${(markup(completedOrderDetails.base_amount).new_price).toFixed(2)}</p>
                                <p style="font-family: 'Prompt', Sans-serif; font-size: 13px;">
                                    Tax Amount: <span style="font-size: 14px; font-family: 'Prompt', Sans-serif; color: rgba(0,0,0,0.7);">
                                    ${get_currency_symbol(completedOrderDetails.tax_currency)}</span>
                                    ${(markup(completedOrderDetails.tax_amount).new_price).toFixed(2)}</p>
                                ${EXTRAS_MARKUP}
                                <p style="font-family: 'Prompt', Sans-serif; font-size: 14px; font-weight: bolder;">
                                    Total Paid: <span style="font-size: 14px font-family: 'Prompt', Sans-serif; color: rgba(0,0,0,0.7);">
                                    ${get_currency_symbol(completedOrderDetails.total_currency)}
                                    </span>
                                    ${(markup(overallTotal).new_price).toFixed(2)}</p>
                            </div>
                        <h1 style="font-family: 'Prompt', Sans-serif; font-size: 17px; margin-bottom: 10px; margin-top: 35px;">
                            Important Notices</h1>
                            <div style="padding: 10px; margin-bottom: 10px; background-color: rgba(0,255,0,0.1); border: 1px solid rgba(0,255,0,0.1); borderRadius: 4px;">
                                ${IMPORTANT_NOTICES}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`

}

export default FlightConfirmationEmailMarkup;